/** Local mirror of https://poojasharma.com.np/design - files live in `public/site-assets/`. */
export function localAsset(relativePath) {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const path = relativePath.replace(/^\//, '');
  return `${base}/site-assets/${path}`;
}

export const galleryCategories = [
  {
    id: 'logo',
    title: 'Logo design',
    description: 'Creative and unique logos for brands and businesses.',
    thumbMode: 'contain',
    frameRatio: 'landscape',
    items: [
      { kind: 'image', path: 'src/design/logo/gamekunda.png', label: 'Gamekunda' },
      { kind: 'image', path: 'src/design/logo/allstar.jpeg', label: 'AllStar' },
      { kind: 'image', path: 'src/design/logo/et.jpeg', label: 'ET' },
      { kind: 'image', path: 'src/design/logo/prime.jpeg', label: 'Prime' },
      { kind: 'image', path: 'src/design/logo/primeus.jpeg', label: 'Prime US' },
      { kind: 'image', path: 'src/design/logo/redreingup.jpeg', label: 'Red re-ing up' },
      { kind: 'image', path: 'src/design/logo/redring.jpeg', label: 'Red ring' },
    ],
  },
  {
    id: 'card',
    title: 'Card design',
    description: 'Elegant and professional card designs for various needs.',
    thumbMode: 'contain',
    frameRatio: 'landscape',
    items: [
      { kind: 'image', path: 'src/design/card/front.jpeg', label: 'Card - front' },
      { kind: 'image', path: 'src/design/card/easyservice.jpeg', label: 'Easy service' },
      { kind: 'image', path: 'src/design/card/back.jpeg', label: 'Card - back' },
      { kind: 'image', path: 'src/design/card/stayhome.jpeg', label: 'Stay home' },
    ],
  },
  {
    id: 'brochure',
    title: 'Brochure design',
    description: 'Engaging brochures to promote your brand or service.',
    thumbMode: 'contain',
    frameRatio: 'landscape',
    items: [
      { kind: 'image', path: 'src/design/broucher/1.jpeg', label: 'Brochure 1' },
      { kind: 'image', path: 'src/design/broucher/2.jpeg', label: 'Brochure 2' },
      { kind: 'image', path: 'src/design/broucher/3.jpeg', label: 'Brochure 3' },
      { kind: 'image', path: 'src/design/broucher/4.jpeg', label: 'Brochure 4' },
      { kind: 'image', path: 'src/design/broucher/5.jpeg', label: 'Brochure 5' },
    ],
  },
  {
    id: 'banner',
    title: 'Banner design',
    description: 'High-quality banners for online and offline marketing.',
    thumbMode: 'contain',
    frameRatio: 'portrait',
    items: [
      { kind: 'image', path: 'src/design/banner/1.jpeg', label: 'Banner 1' },
      { kind: 'image', path: 'src/design/banner/2.jpeg', label: 'Banner 2' },
      { kind: 'image', path: 'src/design/banner/4.jpeg', label: 'Banner 3' },
    ],
  },
  {
    id: 'social',
    title: 'Social media design',
    description: 'Designs for social media marketing and engagement.',
    thumbMode: 'contain',
    frameRatio: 'square',
    items: [
      { kind: 'image', path: 'src/design/social/9.jpeg', label: 'Social 9' },
      { kind: 'image', path: 'src/design/social/8.jpeg', label: 'Social 8' },
      { kind: 'image', path: 'src/design/social/7.jpeg', label: 'Social 7' },
      { kind: 'image', path: 'src/design/social/6.jpeg', label: 'Social 6' },
      { kind: 'image', path: 'src/design/social/5.jpeg', label: 'Social 5' },
      { kind: 'image', path: 'src/design/social/4.jpeg', label: 'Social 4' },
      { kind: 'image', path: 'src/design/social/3.jpeg', label: 'Social 3' },
      { kind: 'image', path: 'src/design/social/2.jpeg', label: 'Social 2' },
      { kind: 'image', path: 'src/design/social/1.jpeg', label: 'Social 1' },
    ],
  },
  {
    id: 'motion',
    title: 'Video & motion',
    description: 'Motion and edited video samples.',
    frameRatio: 'video',
    items: [
      {
        kind: 'video',
        path: 'src/MotionDesign/WhatsApp Video 2024-11-23 at 7.46.34 PM.mp4',
        label: 'Motion sample 1',
      },
      { kind: 'video', path: 'src/MotionDesign/Man.mp4', label: 'Man' },
      { kind: 'video', path: 'src/MotionDesign/Timeline 1.mp4', label: 'Timeline 1' },
      {
        kind: 'video',
        path: 'src/MotionDesign/Tihar Sale-a-bration 2.mp4',
        label: 'Tihar Sale-a-bration',
      },
      { kind: 'video', path: 'src/MotionDesign/Comp 1_1.mp4', label: 'Comp 1 - version A' },
      { kind: 'video', path: 'src/MotionDesign/Comp 1.mp4', label: 'Comp 1' },
    ],
  },
];
